/**
 * Mobile Categories Slider
 * Initializes horizontal slider for category navigation on mobile
 */

$(document).ready(function () {
    'use strict';

    /**
     * Mobile Categories Slider Handler
     */
    class MobileCategoriesSlider {
        constructor() {
            this.sliderContainer = '.mobile-categories-slider';
            this.sliderWrapper = '.mobile-categories-slider .swiper-wrapper';
            this.swiperInstance = null;
            this.init();
        }

        init() {
            if ($(this.sliderContainer).length) {
                this.populateCategories();
            }
        }

        populateCategories() {
            // Wait for the mobile menu interceptor to clone the menu
            setTimeout(() => {
                this.extractCategoriesFromMenu();
            }, 100);
        }

        extractCategoriesFromMenu() {
            // Try to get categories from the sidebar menu first (if not destroyed yet)
            let $menuSource = $('#side_stmobilemenu #st_mobile_menu_ul');

            // If sidebar is destroyed, get from the cloned inline menu
            if (!$menuSource.length) {
                $menuSource = $('#mobile_menu_container #st_mobile_menu_ul_inline');
            }

            if (!$menuSource.length) {
                console.warn('⚠️ No mobile menu found for categories extraction');
                return;
            }

            // Find first menu item with submenu (categories)
            const $firstMenuWithCategories = $menuSource.find('.mo_ml_level_0').first();

            if (!$firstMenuWithCategories.length) {
                console.warn('⚠️ No menu items found');
                return;
            }

            // Extract category links from the grid
            const $categoryItems = $firstMenuWithCategories.find('.mobile-category-item .mobile-category-link');

            if (!$categoryItems.length) {
                console.warn('⚠️ No categories found in first menu item');
                return;
            }

            // Generate slider slides
            let slidesHtml = '';
            $categoryItems.each((index, item) => {
                const $item = $(item);
                const href = $item.attr('href');
                const title = $item.attr('title') || '';
                const name = $item.find('.category-name').text().trim();

                if (name) {
                    slidesHtml += `
                        <div class="swiper-slide">
                            <a href="${href}" class="mobile-category-slide-item" title="${title}">
                                <span class="category-slide-name">${name}</span>
                            </a>
                        </div>
                    `;
                }
            });

            // Populate slider
            $(this.sliderWrapper).html(slidesHtml);

            // Initialize Swiper after population
            this.initSwiper();


        }

        initSwiper() {
            this.swiperInstance = new Swiper(this.sliderContainer, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                freeMode: true,
                grabCursor: true,
                centeredSlides: false,
                watchSlidesProgress: true,
                touchEventsTarget: 'container',
                // Smooth sliding effect
                speed: 400,
                // Touch threshold
                threshold: 10,
                // Mouse wheel control
                mousewheel: {
                    forceToAxis: true,
                    sensitivity: 1,
                    releaseOnEdges: true
                }
            });


        }

        // Method to refresh slider (useful if content changes)
        refresh() {
            if (this.swiperInstance) {
                this.swiperInstance.update();

            }
        }

        // Method to repopulate categories (if menu changes)
        repopulate() {
            this.destroy();
            this.populateCategories();

        }

        // Method to destroy slider
        destroy() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
                this.swiperInstance = null;

            }
        }
    }

    // Initialize mobile categories slider
    const mobileCategoriesSlider = new MobileCategoriesSlider();

    // Expose for debugging
    window.mobileCategoriesSlider = mobileCategoriesSlider;


}); 